/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Types of NDVR (Network DVR) playback scenarios.
 * Distinguishes between different NDVR content structures.
 */
export enum NdvrPlaybackType {
  /**
   * Single recording playback.
   */
  RECORDING = "RECORDING",

  /**
   * Content-based playback (e.g., episode from a series).
   */
  CONTENT = "CONTENT",

  /**
   * Unified collection playback (e.g., all episodes of a series).
   */
  UNIFIED_COLLECTION = "UNIFIED_COLLECTION"
}
